module.exports = __webpack_public_path__ + "media/images/flags/64/Kyrgyzstan-6494e08e1ada05f3af9742cfac0e965d.png";